import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'
import { ApiError } from '../statisticsRoot.reducer'

import {
  exportFacebookPageStatisticsForRange,
  exportInstagramPageStatisticsForRange,
  exportPublishedPostsCountForTemplateStatistics,
  exportPublishedTemplatesByCreatorForRange, findPostTemplatesByMetric,
  getEditorFacebookPageStatistics,
  getEditorInstagramPageStatistics,
  getInsightsForPublishedPosts,
  getInsightsForPublishedPostsBefore, getInsightsForPublishedTemplatesInRange,
  getPublishedPostsByTemplateCount,
  getPublishedTemplateCount,
} from './statistics.editor.actions'
import { FacebookPageInsights, InstagramPageInsights } from '@professocialApi/professocial-core-frontend-api/models'
import {
  AggregatedPublishedCounts,
  AggregatedPublishedPostInsights, PostTemplatesByMetricSearchResult
} from '@3m5/sm_publish-frontend-api/models'
import { PublishedTemplatePostInsights } from '@3m5/sm_publish-frontend-api/models/PublishedTemplatePostInsights'

export interface StatisticsEditorState {
  fetching: boolean
  facebookPageStatistics?: FacebookPageInsights[]
  facebookExportedStatistics?: Blob
  instagramExportedStatistics?: Blob
  instagramPageStatistics?: InstagramPageInsights[]
  postTemplatesByMetric?: PostTemplatesByMetricSearchResult
  aggregatedPublishedPostsInsights?: AggregatedPublishedPostInsights
  aggregatedPublishedPostsInsightsBefore?: AggregatedPublishedPostInsights
  aggregatedPublishedTemplateCounts?: AggregatedPublishedCounts
  aggregatedPublishedPostsByTemplateCounts?: AggregatedPublishedCounts
  aggregatedPublishedTemplateExportedStatistics?: Blob
  aggregatedPublishedPostsExportedStatistics?: Blob
  publishedTemplatesStatistics?: PublishedTemplatePostInsights[]
  error: ApiError
}

const INITIAL_STATE: StatisticsEditorState = {
  fetching: false,
  error: {},
}

export const StatisticsEditorReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getEditorFacebookPageStatistics
   */
  .case(getEditorFacebookPageStatistics.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getFacebookPageStatistics
    })
  })

  .case(getEditorFacebookPageStatistics.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookPageStatistics = result
      draft.fetching = false
    })
  })

  .case(getEditorFacebookPageStatistics.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getFacebookPageStatistics = (error as Response)
    })
  })

  /**
   * getEditorInstagramPageStatistics
   */
  .case(getEditorInstagramPageStatistics.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPageStatistics
    })
  })

  .case(getEditorInstagramPageStatistics.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramPageStatistics = result
      draft.fetching = false
    })
  })

  .case(getEditorInstagramPageStatistics.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPageStatistics = (error as Response)
    })
  })

  /**
   * findPostTemplatesByMetric
   */
  .case(findPostTemplatesByMetric.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.findPostTemplatesByMetric
    })
  })

  .case(findPostTemplatesByMetric.done, (state, { result }) => {
    return produce(state, draft => {
      draft.postTemplatesByMetric = result
      draft.fetching = false
    })
  })

  .case(findPostTemplatesByMetric.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.findPostTemplatesByMetric = (error as Response)
    })
  })

/**
   * exportFacebookPageStatisticsForRange
   */
  .case(exportFacebookPageStatisticsForRange.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPostsInRangeForPage
    })
  })

  .case(exportFacebookPageStatisticsForRange.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookExportedStatistics = result
      draft.fetching = false
    })
  })

  .case(exportFacebookPageStatisticsForRange.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPostsInRangeForPage = (error as Response)
    })
  })

  /**
   * exportInstagramPageStatisticsForRange
   */
  .case(exportInstagramPageStatisticsForRange.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPostsInRangeForPage
    })
  })

  .case(exportInstagramPageStatisticsForRange.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramExportedStatistics = result
      draft.fetching = false
    })
  })

  .case(exportInstagramPageStatisticsForRange.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPostsInRangeForPage = (error as Response)
    })
  })

/**
   * getInsightsForPublishedPosts
   */

  .case(getInsightsForPublishedPosts.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedPostsInsights = result
    })
  })


/**
   * getInsightsForPublishedPostsBefore
   */

  .case(getInsightsForPublishedPostsBefore.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedPostsInsightsBefore = result
    })
  })


/**
   * getPublishedTemplateCount
   */

  .case(getPublishedTemplateCount.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedTemplateCounts = result
    })
  })

/**
   * getPublishedPostsByTemplateCount
   */

  .case(getPublishedPostsByTemplateCount.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedPostsByTemplateCounts = result
    })
  })

/**
   * exportPublishedPostsCountForTemplateStatistics
   */

  .case(exportPublishedPostsCountForTemplateStatistics.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedTemplateExportedStatistics = result
    })
  })

/**
   * exportPublishedTemplatesByCreatorForRange
   */

  .case(exportPublishedTemplatesByCreatorForRange.done, (state, { result }) => {
    return produce(state, draft => {
      draft.aggregatedPublishedPostsExportedStatistics = result
    })
  })

/**
   * getInsightsForPublishedTemplatesInRange
   */

  .case(getInsightsForPublishedTemplatesInRange.done, (state, { result }) => {
    return produce(state, draft => {
      draft.publishedTemplatesStatistics = result
    })
  })

